// GET_CURRENCY
export const GET_CURRENCY = "GET_CURRENCY";
export const GET_CURRENCY_FAIL = "GET_CURRENCY_FAIL";
export const GET_CURRENCY_SUCCESS = "GET_CURRENCY_SUCCESS";

